import _ from 'lodash';
import { getEmailRegexMatch } from '~/app/common/utils';
import { LEARN_REDIRECT_EMAIL_DOMAINS } from '../constants';

export const isValidString = (value) => {
  // Was the value set
  if (!value) {
    return false;
  }

  // Is the value just empty space?
  if (value.trim && !value.trim()) {
    return false;
  }

  return true;
};

export const normalizeStringLength = maxLength => (value, previousValue) => {
  if (_.isUndefined(value)) {
    return previousValue;
  }

  return _.truncate(value, { length: maxLength, omission: '' });
};

export const emailMatchesLearnRedirectDomain = (email) => {
  const domain = _.toLower(_.get(getEmailRegexMatch(email), 'groups.domain', ''));
  return !_.isEmpty(domain) && _.includes(LEARN_REDIRECT_EMAIL_DOMAINS, domain);
};
